import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCirclesThree: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconCirclesThree"><Path d="M8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2Z" fill="currentColor"/><Path d="M14.5 13C12.0147 13 10 15.0147 10 17.5C10 19.9853 12.0147 22 14.5 22C16.9853 22 19 19.9853 19 17.5C19 15.0147 16.9853 13 14.5 13Z" fill="currentColor"/><Path d="M15 9.5C15 7.567 16.567 6 18.5 6C20.433 6 22 7.567 22 9.5C22 11.433 20.433 13 18.5 13C16.567 13 15 11.433 15 9.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCirclesThree;
